import angular from 'angular';

import './sidenav.scss';

import {Sidenav} from './sidenav.component';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.layout.sidenav', [])
  .component('sidenavComponent', Sidenav)
  .name;
